import { CheckableFieldComponent } from "./chunk-56AZ6LJP.js";
import { Radio_default } from "./chunk-NCB6PQYR.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCard/RadioCard.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var RADIO_CARD_CLASSNAME_MAP = {
  validation: {
    error: "pd-radio-card--error",
    success: "pd-radio-card--success",
    warning: "pd-radio-card--warning",
    info: "pd-radio-card--info",
    dim: "pd-radio-card--dim"
  }
};
var RadioCard = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      image,
      secondaryAction,
      badge,
      validation,
      validationMessage,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "image", "secondaryAction", "badge", "validation", "validationMessage", "className"]);
  return /* @__PURE__ */React.createElement(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    validation,
    validationMessage,
    className: clsx("pd-radio-card pd-radio-card--primary", validation && RADIO_CARD_CLASSNAME_MAP.validation[validation], className)
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Input, __spreadValues({
    ref,
    as: Radio_default,
    className: "pd-radio-card__input"
  }, rest)), /* @__PURE__ */React.createElement(CheckableFieldComponent.Wrap, {
    className: "pd-radio-card__wrap"
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Image, {
    className: "pd-radio-card__img"
  }, image), /* @__PURE__ */React.createElement(CheckableFieldComponent.Label, {
    className: "pd-radio-card__label"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Description, {
    className: "pd-radio-card__description"
  }), (secondaryAction || badge || validation) && /* @__PURE__ */React.createElement("footer", {
    className: "pd-radio-card__footer"
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.SecondaryAction, {
    className: "pd-radio-card__secondary-action"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Badge, {
    className: "pd-radio-card__badge"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Validation, {
    className: "pd-radio-card__validation"
  }))));
});
var RadioCard_default = RadioCard;
export { RadioCard_default };